import { Injectable } from '@angular/core';
import { icons } from '@appCore/constants/icons';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  private path: string = "assets/static/svg";

  constructor(private domSanitizer: DomSanitizer, public matIconRegistry: MatIconRegistry) {}

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
   }

  loadIcons() {
    icons.forEach(
      (icon:any) => this.matIconRegistry.addSvgIcon(icon, this.setPath(`${this.path}/${icon}.svg`))
    )
  }
}
